import type { NGDropdownListItem } from "@common/components/ui-components/SXDropdown";

export const languages: NGDropdownListItem<string>[] = [
  { id: "en", name: "English", flag: "fi fi-gb" },
  { id: "sv", name: "Svenska", flag: "fi fi-se" },
  { id: "da", name: "Dansk", flag: "fi fi-dk" },
  { id: "fi", name: "Finska", flag: "fi fi-fi" },
  // { id: "lt", name: "Lietuvių", flag: "fi fi-lt" },
  // { id: "nl ", name: "Nederlands", flag: "fi fi-nl" },
];
